import classnames from 'classnames';
import { useRef } from 'react';

import { useAccessibleInteractivity } from '../../../../../hooks';

const ChildListItem = ({ name, onClick, selected, slug, title }) => {
  const linkRef = useRef();
  useAccessibleInteractivity(linkRef, onClick);

  return (
    <li key={slug} className="child">
      <a
        className={selected ? 'selected' : ''}
        data-track="filter"
        data-track-filter-name={title}
        data-track-filter-option={name}
        ref={linkRef}
      >
        {name}
      </a>
    </li>
  );
};

export default ChildListItem;
